import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  justify-content: space-between;

  .subHeader {
    display: flex;
    gap: 1rem;
    align-items: center;

    h1 {
      color: #b10000;
      font-size: 1.3rem;
      margin: 0;
      font-weight: 300;
    }
  }
  svg {
    height: 2rem;
    fill: #b10000;
  }
  button {
    color: ${({ theme }) => theme.colors.background_white};
    background: ${({ theme }) => theme.colors.tertiary_500};
    border: none;
    border-radius: 2rem;
    cursor: pointer;
  }
`;
export const ContentModal = styled.div`
  h2 {
    margin: 1rem 0 0.5rem 0;
    font-size: 14px;
    color: #8d8d8d;
    font-weight: 300;
  }
  p {
    font-weight: 300;
    color: ${({ theme }) => theme.colors.secondary};
    font-size: 18px;
    &:first-child {
      margin-bottom: 0.5rem;
    }
  }
  .buttonModal {
    display: flex;
    justify-content: space-between;
    margin: 2rem 1rem 0 0;
  }
`;
